import breev from '../../../helpers/breev';

const outcomeText = (a, b) => {
  return a === b ? 'Victory' : 'Defeat';
};

// The mirrored "team A vs team B" lineup header with objective-count stats and
// K/D/A blocks down the middle. The objective counts and centre K/D/A values are
// the existing hardcoded placeholder data, relocated here.
// Args:
//   @teamA, @teamB - team models (logo.url, name, country, slug)
//   @match         - match model (isFinal, victor.slug)
const blueObjectives = [
  { icon: 'tower-icon', count: '7' },
  { icon: 'inhibitor-icon', count: '0' },
  { icon: 'baron-icon', count: '1' },
  { icon: 'dragon-icon', count: '1' },
  { icon: 'rift-herald-icon', count: '0' },
];

const redObjectives = [
  { icon: 'rift-herald-icon', count: '0' },
  { icon: 'dragon-icon', count: '2' },
  { icon: 'baron-icon', count: '1' },
  { icon: 'inhibitor-icon', count: '0' },
  { icon: 'tower-icon', count: '3' },
];

const objectiveHref = (icon) => {
  return '#svg-' + icon.replace('-icon', '');
};

<template>
  <div class='team-lineups-header medium full'>
    <div class='team-info-wrap mid'>
      <img class='team-logo mid' src='{{@teamA.logo.url}}' alt='{{@teamA.name}}' />
      <div class='team-info'>
        <p class='team-name'>
          {{breev @teamA.name}}
          {{#if @match.isFinal}}
            |
            <span class='highlight team-blue'>{{outcomeText @match.victor.slug @teamA.slug}}</span>
          {{/if}}
        </p>
        <p class='team-country'>{{@teamA.country}}</p>
      </div>
    </div>
    {{#each blueObjectives as |objective|}}
      <div class='featured-stat-wrap multiple-items'>
        <svg class='featured-stat-icon {{objective.icon}} blue'>
          <use href={{objectiveHref objective.icon}}></use>
        </svg>
        <p class='featured-stat-title'>{{objective.count}}</p>
      </div>
    {{/each}}
    <div class='featured-stat-wrap regular right'>
      <p class='featured-stat-title'><span class='highlight'>36</span>
        /
        <span class='highlight'>27</span>
        /
        <span class='highlight'>70</span></p>
      <p class='featured-stat-text'>K / D / A</p>
    </div>
    <div class='featured-stat-wrap regular left'>
      <p class='featured-stat-title void'><span class='highlight'>27</span>
        /
        <span class='highlight'>37</span>
        /
        <span class='highlight'>31</span></p>
      <p class='featured-stat-text'>K / D / A</p>
    </div>
    {{#each redObjectives as |objective|}}
      <div class='featured-stat-wrap multiple-items inverted'>
        <svg class='featured-stat-icon {{objective.icon}} red'>
          <use href={{objectiveHref objective.icon}}></use>
        </svg>
        <p class='featured-stat-title'>{{objective.count}}</p>
      </div>
    {{/each}}
    <div class='team-info-wrap mid inverted'>
      <img class='team-logo mid' src='{{@teamB.logo.url}}' alt='{{@teamB.name}}' />
      <div class='team-info'>
        <p class='team-name'>
          {{#if @match.isFinal}}
            <span class='highlight red'>{{outcomeText @match.victor.slug @teamB.slug}}</span>
            |
          {{/if}}
          {{breev @teamB.name}}
        </p>
        <p class='team-country'>{{@teamB.country}}</p>
      </div>
    </div>
  </div>
</template>
